import { TenantFeatureFlags } from "@/lib/constants/feature-flags";
import { useTenant } from "@/providers/session";
import { useGetAllBankConnections } from "@/queries/bank-connections/get-all";
import { isProduction } from "../lib/constants/environment";

export default function useReconEnabled() {
  const { bankConnections, loading } = useGetAllBankConnections();
  const { tenantId } = useTenant();

  if (loading) return { reconEnabled: false, loading: true };

  const reconEnabled =
    bankConnections.length > 0 &&
    (isProduction || tenantId === TenantFeatureFlags.RECON_TENANT);

  return {
    reconEnabled,
    hasBankConnections: bankConnections.length > 0,
    loading: false,
  };
}
